import moment from 'moment';

const userDateSetting = 'MM/DD/YYYY';

export const buildDate = (timestamp) => {

    if (!timestamp) {

        return '';

    }

    return moment.utc(timestamp).format(userDateSetting);

};
